const Dashboard = () => import('../pages/dashboard').then(m => m.default || m)
const Login = () => import('../pages/auth/login').then(m => m.default || m)
const NotFound = () => import('../pages/errors/404').then(m => m.default || m)
const Forbidden = () => import('../pages/errors/403').then(m => m.default || m)
const Settings = () => import('../pages/settings/index').then(m => m.default || m)

// receptions / doctor / admin
const Appointments = () => import('../pages/appointments/index').then(m => m.default || m)

// finance
const Payments = () => import('../pages/finance/payments/index').then(m => m.default || m)
const Expenses = () => import('../pages/finance/expenses/index').then(m => m.default || m)

// patients
const Patients = () => import('../pages/patients/index').then(m => m.default || m)
const PatientSummary = () => import('../pages/patients/print_summary').then(m => m.default || m)

// doctors
const DoctorAppointments = () => import('../pages/doctor/index').then(m => m.default || m)
const DoctorAppointmentView = () => import('../pages/doctor/view').then(m => m.default || m)
const PrintPrescription = () => import('../pages/doctor/print').then(m => m.default || m)

// laboratory 
const Lab = () => import('../pages/laboratory/index').then(m => m.default || m)

// pharmacy 
const Pharmacy = () => import('../pages/pharmacy/index').then(m => m.default || m)
const PharmacyNew = () => import('../pages/pharmacy/new').then(m => m.default || m)

// procedure
const ProcedureRoom = () => import('../pages/procedure/index').then(m => m.default || m)

// admin
const BaseInfo = () => import('../pages/admin/index').then(m => m.default || m)

// reports
const Reports = () => import('../pages/reports/index').then(m => m.default || m)
const ReportsSummary = () => import('../pages/reports/summary').then(m => m.default || m)
const ReportsAppointments = () => import('../pages/reports/appointments').then(m => m.default || m)
const ReportsExpenses = () => import('../pages/reports/expenses').then(m => m.default || m)
const ReportsPayments = () => import('../pages/reports/payments').then(m => m.default || m)

const ReportsDiagnoses = () => import('../pages/reports/diagnoses').then(m => m.default || m)

export default [
    {
        path: '/', name: 'dashboard', component: Dashboard, meta: {
            autoMatch: true
        }
    },

    { path: '/login', name: 'login', component: Login },
    {
        path: '/settings',
        component: Settings,
        name: 'Settings'
    },
    {
        path: '/appointments',
        component: Appointments,
        name: 'Appointments'
    },
    {
        path: '/payments',
        component: Payments,
        name: 'Payments'
    },
    {
        path: '/patients',
        component: Patients,
        name: 'Patients'
    },
    {
        path: '/patients/print/summary',
        component: PatientSummary,
        name: 'Patient Records Print'
    },
    {
        path: '/doctor/appointments',
        component: DoctorAppointments,
        name: 'Doctor | Appointments'
    },
    {
        path: '/doctor/appointments/:id',
        component: DoctorAppointmentView,
        name: 'Doctor | View Appointment '
    },
    {
        path: '/laboratory',
        component: Lab,
        name: 'Laboratory | Test List'
    },

    {
        path: '/pharmacy',
        component: Pharmacy,
        name: 'Pharmacy | Prescriptions'
    },

    {
        path: '/pharmacy/new',
        component: PharmacyNew,
        name: 'Pharmacy | New Prescription'
    },

    {
        path: '/procedure',
        component: ProcedureRoom,
        name: 'Procedure Room'
    },

    {
        path: '/expenses',
        component: Expenses,
        name: 'Expenses'
    },

    {
        path: '/base_info',
        component: BaseInfo,
        name: 'Base Information'
    },

    {
        path: '/reports',
        component: Reports,
        name: 'Reports'
    },

    {
        path: '/reports/summary',
        component: ReportsSummary,
        name: 'Summary Report'
    },

    {
        path: '/reports/appointments',
        component: ReportsAppointments,
        name: 'Appointments Report'
    },

    {
        path: '/reports/expenses',
        component: ReportsExpenses,
        name: 'Expenses Report'
    },

    {
        path: '/reports/payments',
        component: ReportsPayments,
        name: 'Payments Report'
    },

    {
        path: '/reports/diagnoses',
        component: ReportsDiagnoses,
        name: 'Diagnoses Report'
    },

    {
        path: '/print/prescription',
        component: PrintPrescription,
        name: 'Print Prescription'
    },

    {
        path: '/403',
        component: Forbidden
    },


    { path: '*', component: NotFound }
]